var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9373 9.00003V11.535C15.9375 11.8681 15.872 12.1979 15.7447 12.5056C15.6174 12.8133 15.4307 13.093 15.1953 13.3285C14.9599 13.5641 14.6804 13.7509 14.3727 13.8784C14.0651 14.0059 13.7353 14.0715 13.4023 14.0715H6.49552C5.82325 14.0709 5.17874 13.8033 4.70377 13.3275L2.41477 10.2C2.18478 9.84205 2.0625 9.42552 2.0625 9.00003C2.0625 8.57453 2.18478 8.158 2.41477 7.80003L4.70527 4.67253C4.94054 4.43686 5.21994 4.24985 5.52751 4.1222C5.83507 3.99454 6.16477 3.92873 6.49777 3.92853H13.4023C13.7353 3.92853 14.0651 3.99415 14.3727 4.12164C14.6804 4.24913 14.9599 4.43599 15.1953 4.67154C15.4307 4.9071 15.6174 5.18673 15.7447 5.49446C15.872 5.8022 15.9375 6.132 15.9373 6.46503V9.00003Z",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18262 7.1573C8.31483 6.86931 8.53926 6.63361 8.82042 6.48746C9.10159 6.34131 9.42345 6.29304 9.73512 6.3503C9.9487 6.38285 10.1517 6.46509 10.3276 6.59041C10.5036 6.71573 10.6477 6.88061 10.7484 7.0718C10.8211 7.22465 10.8606 7.39118 10.8642 7.5604C10.8679 7.72963 10.8357 7.89771 10.7698 8.05359C10.7038 8.20947 10.6056 8.34961 10.4815 8.46478C10.3575 8.57996 10.2105 8.66755 10.0501 8.7218C9.88665 8.78379 9.74521 8.8928 9.64363 9.03509C9.54206 9.17738 9.4849 9.34656 9.47937 9.5213V9.8513",
    stroke: "#3F3F3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4541 11.6738H9.45677",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqCategory);
export default __webpack_public_path__ + "static/media/faq-category.c3b26386f74ba4fa5b670f7f2168bee4.svg";
export { ForwardRef as ReactComponent };